import type { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type CreateAwayScheduleBlockV2Request =
  paths['/v2/users/me/away-schedule']['post']['requestBody']['content']['application/json'];

/**
 * Schedules an away block. A rejected block throws an `ApiError` whose message
 * is the server's explanation, so a surface can show it when the client-side
 * validator let something through.
 */
export async function createAwayScheduleBlockV2({
  startDate,
  endDate,
}: CreateAwayScheduleBlockV2Request) {
  const { data } = await fetchClient.POST('/v2/users/me/away-schedule', {
    body: {
      startDate,
      endDate,
    },
  });

  return data?.data;
}
